export default __webpack_public_path__ + "static/media/excel.71410efc.png";